import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { GetTagesDatenQuery } from '@/gql/graphql';

type SchichtenQueryResult =
  GetTagesDatenQuery['termine_termineKalenderByStandortIdAndZeitraum'][0]['termine'][0]['termine_schichten'];

export function mapSchichten(schichten: SchichtenQueryResult): Schichten[] {
  if (!schichten) return [];

  const schichtenmap = schichten.map((schicht) => ({
    id: schicht.id,
    name: schicht.name,
    datum: schicht.datum,
    beginn: schicht.beginn,
    ende: schicht.ende,
    markierung: schicht.markierung,
    arbeitsbereich: {
      markierung: schicht.termine_arbeitsbereich.markierung,
      name: schicht.termine_arbeitsbereich.name,
    },
    mitarbeiter: schicht.termine_mitarbeiter.map((m) => ({
      id: m.id,
      vorname: m.vorname,
      nachname: m.nachname,
      bildUrl: m.bildUrl,
    })),
  }));

  return schichtenmap;
}
